/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_TitleInputs */

const en_admin_invite_codes_delete_title = /** @type {(inputs: Admin_Invite_Codes_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete invite code?`)
};

const zh_admin_invite_codes_delete_title = /** @type {(inputs: Admin_Invite_Codes_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认删除邀请码?`)
};

/**
* | output |
* | --- |
* | "Delete invite code?" |
*
* @param {Admin_Invite_Codes_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_title = /** @type {((inputs?: Admin_Invite_Codes_Delete_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_delete_title(inputs)
	return zh_admin_invite_codes_delete_title(inputs)
});
export { admin_invite_codes_delete_title as "admin.invite_codes.delete_title" }